module.exports = function zeroPad(...numbers) {
    if (numbers.length === 1) {
        return `0${numbers[0]}`.slice(-2);
    }

    return numbers.map(number => `0${number}`.slice(-2));
};
